/* eslint-disable no-unused-vars */
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import { Palette } from 'config';
import { CheckboxInner } from 'components';
import { campaignReportsActions } from 'store/actions';
import { DotsMenu } from '../dotsMenu/DotsMenu';

export const IsBulkActionsComponent = ({ item, env, handleCheckbox, uniqueField, name, id }) => {
  const isBulkActions = useSelector((state) => state.campaignReports.isPressedBulkBtn);
  const selectedTableItems = useSelector((state) => state.campaignReports.selectedTableItems);

  return (
    <>
      {isBulkActions && (
        <CheckboxWrap>
          <CheckboxInner
            name={name}
            isChecked={selectedTableItems.some((el) => el[uniqueField] === item[uniqueField])}
            id={id}
            onChange={() => handleCheckbox({ item, selectedTableItems })}
          />
        </CheckboxWrap>
      )}
      {!isBulkActions && <DotsMenu {...item} env={env} />}
    </>
  );
};

export const IsBulkActions = memo(IsBulkActionsComponent);

export const CheckboxWrap = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 24px;
  border-right: 1px solid ${Palette.PrimaryGray._200};
`;
